<template>
  <v-card
    class=""
    color="#EFF3F8"
    outlined
  >
    <v-container class="text-uppercase">
      <v-row>
        <v-col cols="1">
          <v-checkbox
            @click="handleCheckboxClick"
            :value="isSelected"
            color="primary"
            class="ml-1 mt-0"
            readonly
            hide-details
            dense
          />
        </v-col>

        <v-col>
          <div>Cronograma</div>
          <div><b>{{ faturamentoLote.cronograma.dataFaturamento | formatDate }}</b></div>
        </v-col>

        <v-col>
          <div>Nº lote</div>
          <div><b>{{ faturamentoLote.numeroLote }}</b></div>
        </v-col>

        <v-col>
          <div>Total</div>
          <div><b>{{ faturamentoLote.valorTotal | formatCurrency }}</b></div>
        </v-col>

        <v-col>
          <div>Qtde. guias</div>
          <div><b>{{ faturamentoLote.quantidadeGuias }}</b></div>
        </v-col>

        <v-col>
          <div>Pago</div>
          <div class="success--text"><b>{{ faturamentoLote.valorPagoConciliacaoItens | formatCurrency }}</b></div>
        </v-col>

        <v-col>
          <div>Glosado</div>
          <div class="red--text"><b>{{ faturamentoLote.valorGlosadoConciliacaoItens | formatCurrency }}</b></div>
        </v-col>

        <v-col>
          <div>Pendente</div>
          <div><b>{{ faturamentoLote.valorTotal - faturamentoLote.valorPagoConciliacaoItens | formatCurrency }}</b></div>
        </v-col>

        <v-col class="d-flex justify-center align-center">
          <v-chip v-if="faturamentoLote.hasBaixa" small color="secondary" class="justify-center">Baixa</v-chip>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { formatCurrency } from '../../../libs'

export default {
  props: {
    isAssociado: Boolean,
    isSelected: Boolean,
    faturamentoLote: Object
  },
  methods: {
    handleCheckboxClick () {
      this.$emit('click:checkbox', this.faturamentoLote, this.isSelected)
    }
  },
  filters: {
    formatCurrency (value) {
      return formatCurrency(value)
    }
  }
}
</script>
